"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAttributionSecretKeyResponseSchema = exports.CreateAttributionSecretKeyBodySchema = exports.AttributionSecretKeyContentFields = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.AttributionSecretKeyContentFields = {
    campaignId: core_1.IdSchema,
};
exports.CreateAttributionSecretKeyBodySchema = (0, core_1.StrictObject)(exports.AttributionSecretKeyContentFields);
exports.GetAttributionSecretKeyResponseSchema = (0, core_1.StrictObject)({
    key: ruby_1.AttributionSecretKeySchema,
});
